import { render, staticRenderFns } from "./table62.vue?vue&type=template&id=0dca8e86&scoped=true&"
import script from "./table62.vue?vue&type=script&lang=js&"
export * from "./table62.vue?vue&type=script&lang=js&"
import style0 from "./table62.vue?vue&type=style&index=0&id=0dca8e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca8e86",
  null
  
)

export default component.exports